import { addListener } from '../../middlewares/listener.middleware';
import { openTicket, TicketsActionsType } from './tickets.action';

addListener(TicketsActionsType.CREATE_TICKET_SUCCESS)((_, action) => {
  return openTicket({ ticketId: action.payload.ticketId });
});
